//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SymptomDetailMixin from '@/views/mixins/guide/SymptomDetailMixin'
import {mapGetters} from 'vuex'

export default {
  name: 'SymptomDetail',
  mixins: [SymptomDetailMixin],
  computed: {
    ...mapGetters([
      'fontColor',
      'bannerColorStart',
      'bannerColorEnd'
    ])
  }
}



// WEBPACK FOOTER //
// ./src/views/guide/colortheme/Detail.vue